import React from "react";
import img from "./img.svg";
import styles from "./index.module.scss";
export default class Union extends React.Component {
    static defaultProps = {
        className: "",
    };
    render() {
        return (React.createElement("img", { src: img, alt: "Union Icon", className: `${styles.union} ${this.props.className}` }));
    }
}
